/**
 * SubtleBackground.tsx
 * Clean gradient background for Tunnel UI
 * 
 * Single Responsibility: Render background visual layer
 * No business logic, no API calls
 * 
 * Reference: TunnelMockupsV5_Final.jsx lines 56-64
 */
import React from 'react';

export const SubtleBackground: React.FC = () => (
  <div className="fixed inset-0 pointer-events-none z-0 bg-slate-950">
    {/* Deep Radial Gradient for subtle depth */}
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-slate-900 via-slate-950 to-slate-950" />
    
    {/* Very subtle bottom glow */}
    <div className="absolute bottom-0 left-0 right-0 h-48 bg-gradient-to-t from-indigo-950/20 to-transparent" />
  </div>
);

export default SubtleBackground;
